import { render, staticRenderFns } from "./SpinnerLoader.vue?vue&type=template&id=3a5eb8ca&scoped=true&"
import script from "./SpinnerLoader.vue?vue&type=script&lang=js&"
export * from "./SpinnerLoader.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerLoader.vue?vue&type=style&index=0&id=3a5eb8ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5eb8ca",
  null
  
)

export default component.exports